module.exports = __webpack_public_path__ + "img/corchete-fondo.a6279a60.svg";